export default __webpack_public_path__ + "static/media/JEWEL.417357b2.png";